
import { z } from "zod";

export const storyFormSchema = z.object({
  title: z.string().min(5, { message: "Title must be at least 5 characters." }),
  subtitle: z.string().min(10, { message: "Subtitle must be at least 10 characters." }),
  excerpt: z.string().min(20, { message: "Excerpt must be at least 20 characters." }),
  content: z.string().min(50, { message: "Content must be at least 50 characters." }),
  coverImage: z.string().url({ message: "Cover image must be a valid URL." }),
  category: z.string().min(1, { message: "Category is required." }),
  authorId: z.string().min(1, { message: "Author is required." }),
  tags: z.string().optional(),
  featured: z.boolean().default(false),
  vimeo: z.string().optional().nullable(),
});

export type StoryFormValues = z.infer<typeof storyFormSchema>;
